import { render } from "./ConfigurationFillUpMenu.vue?vue&type=template&id=b1bcf6bc&scoped=true"
import script from "./ConfigurationFillUpMenu.vue?vue&type=script&lang=js"
export * from "./ConfigurationFillUpMenu.vue?vue&type=script&lang=js"

import "./ConfigurationFillUpMenu.vue?vue&type=style&index=0&id=b1bcf6bc&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1bcf6bc"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QItem,QMenu});
